module.exports = __webpack_public_path__ + "static/media/male.f03b2691.png";